import config from "../config/vars";

export default () => {
  window.localStorage.setItem("path", window.location.pathname);
  window.localStorage.removeItem("auth");
  const hostname =
    window.location.pathname !== "/"
      ? `${window.location.href.substring(
          0,
          window.location.href.indexOf(window.location.pathname)
        )}/`
      : window.location.href;

  const loginUrl = config.loginUrl.replace("{redirect}", hostname);
  window.location.assign(loginUrl);
};
